<template>
    <div class="ticket-stack-widget__system-info">
        <div class="all-tickets-stack__table-header">
            <div class="table-col__first">
            </div>
            <div class="table-col__combinations">
                {{ $t('combinations') | upperCase }}
            </div>
            <div
                v-if="minimumPotentialWin"
                class="table-col__potential-win"
            >
                {{ $t('minimum potential win') | upperCase }}
            </div>
        </div>
        <div class="ticket-stack__item-summary">
            <div class="ticket-stack__item-status">
            </div>
            <div class="ticket-stack__item--combinations">
                <span v-if="fixed">
                    {{ fixed }} {{ $t('fixed') | upperCase }} &#183;
                </span>
                <span>
                    {{systems}}
                </span>
            </div>
            <div
                v-if="minimumPotentialWin"
                class="ticket-stack__item--potential-win"
            >
                {{ minimumPotentialWin | twoDecimals }}
                <span class="ticket-stack__item--currency">
                    {{ $t('currencyAbbreviation') }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        inheritAttrs: false,
        props: {
            fixed: {
                type: Number,
                required: true,
            },
            minimumPotentialWin: {
                type: Number,
                default: null,
            },
            count: {
                type: Number,
                required: true,
            },
            selected: {
                type: Array,
                required: true,
            },
        },
        computed: {
            systems() {
                return this.selected.map((s) => `${s}/${this.count}`).join(', ');
            },
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/shared/tickets/SystemRow.vue